import { render, staticRenderFns } from "./addCrewJob.vue?vue&type=template&id=65c3848f&scoped=true"
import script from "./addCrewJob.vue?vue&type=script&lang=js"
export * from "./addCrewJob.vue?vue&type=script&lang=js"
import style0 from "./addCrewJob.vue?vue&type=style&index=0&id=65c3848f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3848f",
  null
  
)

export default component.exports